import $ from "jquery";
import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  $("body").addClass("is-loaded");

  const openTl = gsap.timeline({
    repeat: 0,
    defaults: { duration: 1, ease: "power4.out" },
  });
  openTl
    .fromTo(
      ".section-hero",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      }
    )
    .fromTo(
      ".p-hero-bg-border",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
      "<"
    )
    .fromTo(
      ".p-hero-bg-image",
      {
        x: 30,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
      },
      "<"
    )
    .fromTo(
      ".p-hero-copy-catch",
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
      ">0.4"
    )
    .fromTo(
      ".p-hero-copy-text",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      },
      "<0.2"
    )
    .fromTo(
      ".p-hero-cta_button",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      },
      "<0.2"
    );
});

$(".a-sec-heading").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 80, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

$(".p-service-text").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 60, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

$(".a-image").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

$(".a-text").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.5,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

const flowPcT2 = gsap.timeline({
  scrollTrigger: {
    trigger: ".p-service-column",
    start: "top 80%",
  },
});
flowPcT2.fromTo(
  ".p-service-column-heading",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

$(".p-column-point-list-item").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

$(".p-service-column-list-item").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

const flowPcT3 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-reason",
    start: "top 60%",
  },
});
flowPcT3.fromTo(
  ".p-reason-heading",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);
flowPcT3.fromTo(
  ".p-reason_item",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);
flowPcT3.fromTo(
  ".p-reason-lead",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

// const flowPcT4 = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".section-service",
//     start: "top 80%",
//   },
// });
// flowPcT4.fromTo(
//   ".p-service-text",
//   {
//     y: 30,
//     opacity: 0,
//   },
//   {
//     y: 0,
//     opacity: 1,
//     ease: "power4.out",
//     stagger: {
//       from: "start",
//       amount: 0.5,
//     },
//   }
// );
// flowPcT4.fromTo(
//   ".p-service-outline",
//   {
//     y: 30,
//     opacity: 0,
//   },
//   {
//     y: 0,
//     opacity: 1,
//     ease: "power4.out",
//     stagger: {
//       from: "start",
//       amount: 0.5,
//     },
//   }
// );

// $(".p-service-heading").each((index, el) => {
//   gsap.fromTo(
//     el,
//     { y: 30, opacity: 0 },
//     {
//       y: 0,
//       opacity: 1,
//       scrollTrigger: {
//         trigger: el,
//         start: "top 90%",
//         ease: "power4.out",
//       },
//     }
//   );
// });

const flowPcT5 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-ourservice",
    start: "top 60%",
  },
});
flowPcT5.fromTo(
  ".p-plan-item",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "end",
      amount: 0.5,
    },
  }
);

const flowPcT6 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-cv",
    start: "top 60%",
  },
});
flowPcT6.fromTo(
  ".section-cv-content",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

const flowPcT7 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-point",
    start: "top 60%",
  },
});
flowPcT7.fromTo(
  ".p-point-head",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);
flowPcT7.fromTo(
  ".p-point-list",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

$(".p-point-list-item").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});

const flowPcT11 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-flow",
    start: "top 60%",
  },
});
flowPcT11.fromTo(
  ".p-flow-heading",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);
flowPcT11.fromTo(
  ".p-flow-list-item",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

const flowPcT12 = gsap.timeline({
  scrollTrigger: {
    trigger: ".o-faq",
    start: "top 60%",
  },
});
flowPcT12.fromTo(
  ".o-faq_list",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

const flowPcT13 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-company",
    start: "top 60%",
  },
});
flowPcT13.fromTo(
  ".accordion-box",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

const flowPcT14 = gsap.timeline({
  scrollTrigger: {
    trigger: ".section-seminar",
    start: "top 60%",
  },
});
flowPcT14.fromTo(
  ".p-seminar-head",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);
flowPcT14.fromTo(
  ".p-seminar-text",
  {
    y: 50,
    opacity: 0,
  },
  {
    y: 0,
    opacity: 1,
    ease: "power4.out",
    stagger: {
      from: "start",
      amount: 0.5,
    },
  }
);

$(".o-footer").each((index, el) => {
  gsap.fromTo(
    el,
    { y: 50, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        ease: "power4.out",
      },
    }
  );
});
